<script setup>
import useAiChat from "@/composables/useAiChat";
import {onMounted} from "vue";
const props = defineProps(['needId']);
const emit = defineEmits(['done']);

const roundFormat = {
    answer: '',
};

const params = {
    url: '/chat-stream/get-match-response',
    roundFormat,
    addEvents: {
        'done': done
    }
}

const {
    question,
    loaderMessage,
    sendRequest,
} = useAiChat(params);

onMounted(() => {
    question.value = props.needId;
    sendRequest();
});

function done() {
    emit('done');
}
</script>

<template>
    <div class="need-page__loader">
        {{loaderMessage}}
    </div>
</template>

<style scoped>

</style>
